<template>
    <div class="cash-register-setup">
        <div class="step-title">{{ $t('get_started.cash_register_setup_title') }}</div>
        <!-- <div class="step-description">{{ $t('get_started.cash_register_setup_description') }}</div> -->

        <v-alert
            class="my-6"
            color="white"
            outlined
            text
            transition="slide-y-transition"
            icon="fal fa-cash-register"
        >
            {{ $t('get_started.cash_register_setup_description') }}
        </v-alert>

        <v-text-field
            v-model="form.name"
            :error-messages="form.$errors.name"
            :label="$t('cash_register.name')"
            @blur="form.validate('name')"
            @input="delete form.$errors.name"
        />

        <v-text-field
            v-if="locale === 'ba'"
            v-model="form.activation_code"
            :error-messages="form.$errors.activation_code"
            :label="$t('cash_register.activation_code')"
            @blur="form.validate('activation_code')"
            @input="delete form.$errors.activation_code"
        />

        <template v-if="locale === 'sr'">
            <v-switch
                v-model="form.limit_payments"
                class="mt-0 mb-6 mx-1"
                hide-details
                :label="$t('cash_register.limited_payments')"
                inset
            />

            <v-alert
                v-show="form.limit_payments"
                type="warning"
                text
                outlined
                transition="slide-y-transition"
            >
                {{ $t('cash_register.limited_payments_description') }}
            </v-alert>
        </template>

        <div class="footer">
            <div class="footer">
                <v-btn
                    class="flex-1 mr-3"
                    color="#282b38"
                    depressed
                    @click="$emit('finish')"
                >
                    {{ $t('general.skip') }}
                </v-btn>
                <v-btn
                    class="flex-1"
                    color="primary"
                    depressed
                    :disabled="form.$busy"
                    :loading="form.$busy"
                    @click="setUpCashRegister"
                >
                    {{ $t('terminals.cash_register_register') }}
                </v-btn>
            </div>
        </div>
    </div>
</template>

<script>
import * as mutationTypes from '@/store/mutationTypes';
import ApiService from '@/services/ApiService';
import CashRegisterService from '@/services/CashRegisterService';
import TerminalService from '@/services/TerminalService';
import CashRegister from '@/models/CashRegister';
import { required, requiredIf } from 'vuelidate/lib/validators';

export default {
    data() {
        return {
            form: this.createForm()
        };
    },

    validations: {
        form: {
            name: { required: required },
            activation_code: { requiredIf: requiredIf(form => locale === 'ba') },
        },
    },

    methods: {
        createForm() {
            return new Form(this, 'form', {
                name: this.$t('general.cash_register') + ' ' + (CashRegister.all().length + 1),
                activation_code: null,
                limit_payments: false,
                uuid: null,
                platform: null,
                manufacturer: null,
                model: null,
            })
        },

        /**
         * Set up cash register
         */
        async setUpCashRegister() {
            if(!this.form.validate()) return

            this.form.uuid = this.device.uuid
            this.form.platform = this.device.platform
            this.form.manufacturer = this.device.manufacturer
            this.form.model = this.device.model

            ApiService.post('/getstarted/cash-register', this.form).then(response => {
                this.$store.commit(mutationTypes.SET_TENANT, { tenant: response.data.tenant });

                CashRegisterService.setCashRegister(response.data.cash_register);

                this.$emit('finish')
            }).catch(error => {
                const errorCode = error.response?.data?.errors?.[0].code || null
                if(errorCode) this.$snackbar(this.$t(`cash_register.error.${errorCode}`), 'error')
                else this.$snackbar(this.$t(`terminals.registration_failed`), 'error')
            });
        }
    },
};
</script>

<style lang="scss" scoped>
.cash-register-setup {
    .step-title {
        margin-bottom: 10px;
        font-size: 20px;
    }

    .step-description {
        margin-bottom: 30px;
        font-size: 14px;
        color: #8f9095;
    }

    .footer {
        position: absolute;
        bottom: 0;
        left: 0;
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: flex-start;
    }
}
</style>
